$( function() {
	initWoocommerceQuantity();
 
	$( document ).on( 'change', 'input.qty', function() {
        var item_hash = $( this ).attr( 'name' ).replace(/cart\[([\w]+)\]\[qty\]/g, "$1");
        var item_quantity = $( this ).val();
        var currentVal = parseFloat(item_quantity);
		var spinner_url = cart_spinner_url.spinner_url;
		block( $( 'div.woocommerce' ), spinner_url );
        $.ajax({
            type: 'POST',
            url: cart_qty_ajax.ajax_url,
            data: {
                action: 'my_cart_qty',
                hash: item_hash,
                quantity: currentVal
            },
            success: function(response) { 
				$('.site-main').html(response);
				unblock( $( 'div.woocommerce' ) );
            }
        }); 
	}); 

	
	$( document ).on( 'click', '.product-remove .remove', function() { 
		var item_hash = $( this ).data( 'item-key' ).replace(/cart\[([\w]+)\]\[qty\]/g, "$1");
        var item_quantity = 0;
        var currentVal = parseFloat(item_quantity);
		var spinner_url = cart_spinner_url.spinner_url;
		block( $( 'div.woocommerce' ), spinner_url );
        $.ajax({
            type: 'POST',
            url: cart_qty_ajax.ajax_url,
            data: {
                action: 'my_cart_qty',
                hash: item_hash,
                quantity: currentVal
            },
            success: function(response) { 
				$('.site-main').html(response);
				unblock( $( 'div.woocommerce' ) );
            }
        }); 
	}); 

	var is_blocked = function ( $node ) {
		return (
			$node.is( '.processing' ) || $node.parents( '.processing' ).length
		);
	};
	
	var block = function ( $node, spinner_url ) {
		if ( ! is_blocked( $node ) ) {
			$node.addClass( 'processing' );
			$node.prepend('<img id="cart-update-spinner" src="' + spinner_url + '" />');
		}
	};
	
	var unblock = function ( $node ) {
		$node.removeClass( 'processing' );
		$node.remove($('#cart-update-spinner'));
	};
});


function initWoocommerceQuantity() {
    $(document).on("click", ".plus, .minus", function () {
        var $qty = $(this).closest(".quantity").find(".qty"),
            currentVal = parseFloat($qty.val()),
            max = parseFloat($qty.attr("max")),
            min = parseFloat($qty.attr("min")),
            step = $qty.attr("step");

        if (!currentVal || currentVal === "" || currentVal === "NaN")
            currentVal = 0;
        if (max === "" || max === "NaN") max = "";
        if (min === "" || min === "NaN") min = 0;
        if (
            step === "any" ||
            step === "" ||
            step === undefined ||
            parseFloat(step) === "NaN"
        )
            step = 1;

        if ($(this).is(".plus")) {
            if (max && (max == currentVal || currentVal > max)) {
                $qty.val(max);
            } else {
                $qty.val(currentVal + parseFloat(step));
            }
        } else {
            if (min && (min == currentVal || currentVal < min)) {
                $qty.val(min);
            } else if (currentVal > 0) {
                $qty.val(currentVal - parseFloat(step));
            }
        }

        $qty.trigger("change");
    });

    $("div.woocommerce").on("change", "input.qty", function () {
        $("[name='update_cart']").removeAttr("disabled");
    });
}
